import Mail from '../../images/mail.png'
import ContactUsImg from '../../images/Group_741.png'
import './ContactUs.scss'


function ContactUs() {
    return (
        <div className="contact-us-wrp wrapper" id='contact'>
            <div className='contact-us-content-wrp'>
                <div className='contact-us-title'>Contact Us</div>
                <div className='contact-us-content'>
                    We have 24X7 support available for answering your queries and helping you deal with any work related issue on our platform
                </div>
                <div className="reach-via-title">Reach us through mail</div>
                <div className="mail-id-wrp">
                    <img src={Mail} alt="mail"/>
                    <div>support@jobfi.in</div>
                </div>
            </div>
            <img className='contact-us-img' src={ContactUsImg} alt='contact-us'/>
        </div>
    );
}

export default ContactUs;